import { AccessRefreshToken, OAuthIntegration } from '@glueapp/graph-types';
import { googleAuthorizeUrl, GoogleBaseIntegration } from '../BaseIntegration';

const googleDriveScopes = 'https://www.googleapis.com/auth/drive';

export const GoogleDriveIntegration: OAuthIntegration<AccessRefreshToken, { GOOGLE_CLIENT_ID: string; GOOGLE_CLIENT_SECRET: string }, {}> =
    {
        integrationType: 'oauth',
        ...GoogleBaseIntegration,
        getAuthorizationUrl(
            oauthState: string,
            redirectUri: string,
            secrets: { GOOGLE_CLIENT_ID: string; GOOGLE_CLIENT_SECRET: string },
        ): string {
            return `${googleAuthorizeUrl}?client_id=${secrets.GOOGLE_CLIENT_ID}&scope=${googleDriveScopes}&access_type=of fline&state=${oauthState}&redirect_uri=${redirectUri}&response_type=code`;
        },
        renderOptionLabel: () => 'Google Calendar',
        requiredSecrets: ['GOOGLE_CLIENT_ID', 'GOOGLE_CLIENT_SECRET'],
        provider: 'google_drive',
        allowedDomains: ['sheets.googleapis.com', 'googleapis.com'],
    };
